import React, { CSSProperties } from "react";

import { IconName } from "../components";
import { useI18n } from "../lib/i18n/i18n_provider";
import { range } from "../lib/js_utils/array_utils";
import { Picker } from "./picker";
import { useAnalytics } from "../lib/analytics/analytics";

export interface QuantityPickerProps {
  value?: number;
  disabled?: boolean;
  onChange: (value: number) => void;
  limitQuantityPicker?: number;
  override?: {
    root?: { style?: CSSProperties };
    view?: { style?: CSSProperties };
    arrow?: { style?: CSSProperties };
  };
  label?: string;
  icon?: IconName;
}

export function QuantityPicker(props: QuantityPickerProps) {
  const {
    disabled,
    value,
    onChange,
    override,
    limitQuantityPicker = 50,
    label = "Quantity:",
    icon = "box",
  } = props;
  const { fbt } = useI18n();

  const options = range(1, limitQuantityPicker).map((n) => ({
    label: `${fbt(label)} ${n}`,
    value: n,
  }));

  const analytics = useAnalytics();

  return (
    <Picker
      icon={icon}
      value={value}
      options={options}
      onChange={(qty) => {
        analytics.event(
          "Quantity Select Click",
          {
            Quantity: qty,
            Source: "WL",
          },
          { onlyProviders: ["mixpanel", "customerio"] }
        );
        onChange(qty);
      }}
      disabled={disabled}
      override={override}
    />
  );
}
